import React, { useState } from 'react'
import { connect } from 'react-redux'
import { getCalls, getUser } from '../selectors'
import { terminateCall, activeCallListFilterChanged } from '../actions'
import Icon from '../components/Icon'
import SearchText from '../components/SearchText'
import SiteDropDown from '../components/SiteDropDown'
import UnitDropDown from '../components/UnitDropDown'
import ResetButton from '../components/ResetButton'

import '../styles/active-calls'

const ActiveCallList = ({ user, calls, onTerminateCall, profiles, sites, units }) => {
    const confirmTerminate = (call) => {
        if (confirm(`Do you want to terminate the call from ${call['source'] ? call['source']['name'] : call['username']} to ${call['destination'] ? call['destination']['name'] : call['dst_username']}?`)) {
            onTerminateCall(call)
        }
    }

    const [filter, setFilter] = useState("")
    const [siteFilter, setSiteFilter] = useState("")
    const [unitFilter, setUnitFilter] = useState(null)

    const resetFilters = () => {
        setFilter("")
        setSiteFilter("")
        setUnitFilter(null)
    }

    const checkFilter = (call, f) => {
        let values = [call['destination'] ? call['destination']['name'] : '',  call['source'] ? call['source']['name'] : '', call['dst_username'], call['start_time'], call['state'], call['username'], call['message']]
        for (let value of values) {
            if (typeof value == "string") {
                value = value.toLowerCase()
                f = f.toLowerCase()
                if (value.indexOf(f) > -1) {
                    return true
                }
            }
        }
        return false
    }

    calls = calls.sort((a, b) => {
        if (user.id === a.initiator && user.id !== b.initiator) return -1
        if (user.id !== a.initiator && user.id === b.initiator) return 1
        if (user.isInUnit(a.username[2]) && !user.isInUnit(b.username[2])) return -1
        if (user.isInUnit(b.username[2]) && !user.isInUnit(a.username[2])) return 1
        return a.start_time.localeCompare(b.start_time) * -1
    })
        .filter((call) => {
            // search filter
            if (filter.length > 0) {
                const filters = filter.split(/\s/).filter(s => s.length > 0)
                for (let f of filters) {
                    if (!checkFilter(call, f)) {
                        return false
                    }
                }
                return true
            } else {
                return true
            }
        })
        .filter((call) => {
            // site filter
            if (siteFilter != '') {
                if (siteFilter == call['destination'] ? call['destination']['site'] : '' || siteFilter == call['source'] ? call['source']['site'] : '') {
                    return true
                } else {
                    return false
                }
            } else {

                return true
            }
        })
        .filter((call) => {
            // unit filter
            if (unitFilter && unitFilter.length == 0) {
                return false
            }
            else if (unitFilter && unitFilter.length > 0) {
                const values = [call['destination'] ? call['destination']['unit_id'] : '', call['source'] ? call['source']['unit_id'] : ''].map(v => parseInt(v, 10))
                for (let value of values) {
                    if (unitFilter.indexOf(value) > -1) {
                        return true
                    }
                }
                return false
            } else {
                return true
            }
        })

    return (
        <div className="active-calls">
            <div className="toolbar">
                <div className="activeCallList-filter">
                    <SearchText filter={filter} onChange={setFilter} className="filter" />
                    <SiteDropDown filter={siteFilter} onChange={setSiteFilter} className="filter" sites={sites} />
                    <UnitDropDown filter={unitFilter} onChange={setUnitFilter} className="filter" units={units} />
                    <ResetButton onChange={resetFilters} className="filter" />
                </div>
            </div>
            {calls.map((call, idx) => (
                <div key={`${call.username}-${call.dst_username}_${idx}`} className="call">
                    <div className="subscribers">
                        {call.source ?
                            <div className="subscriber source">
                                <h5>{call.source.name} <small>{call.source.username}</small></h5>
                            </div> :
                            <div className="subscriber source"><h5>{call.username}</h5></div>
                        }
                        {call.destination ?
                            <div className="subscriber destination">
                                <h5>{call.destination.name} <small>{call.destination.username}</small></h5>
                            </div> :
                            <div className="subscriber destination"><h5>{call.dst_username}</h5></div>
                        }
                    </div>
                    <div className="call-info">
                        {call.message &&
                            <div>{call.message}</div>
                        }
                        {call.profile &&
                            <div>
                                {profiles.filter(p => p.value === call.profile).map(p => `${p.name} (${p.description})`)[0] || call.profile}
                            </div>
                        }
                    </div>
                    <div className="action-row">
                        <div>
                            Initiated {call.start_time}&nbsp;
                            {call.initiator && (<span>by {call.initiator}</span>)}
                        </div>
                        <div className="actions">
                            {(call.source && user.isInUnit(call.source.unit_id) || call.destination && user.isInUnit(call.destination.unit_id)) &&
                                <button type="button" className="btn btn-danger" onClick={() => confirmTerminate(call)}>
                                    <Icon icon="phone-alt" />&nbsp;Terminate call
                            </button>
                            }
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}

const mapStateToProps = state => {
    return {
        profiles: state.config.profiles,
        user: getUser(state),
        calls: getCalls(state),
        sites: state.config.sites,
        units: state.config.units
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onTerminateCall: call => dispatch(terminateCall(call)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ActiveCallList)


// WEBPACK FOOTER //
// ./containers/ActiveCallList.jsx